export const normalizeNextLinkHref = (href) => {
  if (!href) return href;

  try {
    const url = new URL(href, window.location.origin);
    const pathname = url.pathname.replace(/^\/v1(?=\/|$)/, "") || "/";

    return `${pathname}${url.search}${url.hash}`;
  } catch (error) {
    return href;
  }
};
